import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, withStyles, Typography, TableSortLabel } from '@material-ui/core';
import moment from 'moment-timezone';
import classNames from 'classnames';

import { sortTable } from '../../helpers/appHelpers';
import { appConstants } from '../../constants/appConstants';
import Styles from '../../layouts/Styles.jsx';
import NotificationStyles from './NotificationStyles.jsx';
import Loader from '../Loaders/Loader.jsx';
import Nomessages from '../../assets/images/NoNotification.svg';

const NotificationGridView = (props) => {
    const { classes, onScrollChange, isPageLoading, notifications } = props;
    const [orderBy, setOrderBy] = useState('');
    const [order, setOrder] = useState('asc');
    const datetimeFormat = 'MM/DD/YYYY HH:mm:ss';

    const onChangeOrder = useCallback((property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    }, [order, orderBy]);

    const onScroll = (event) => {
        if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight && onScrollChange) {
            onScrollChange();
        }
    };

    return (
        <Grid className={classNames(classes.notificationContainer, classes.tableWrapperStyle)} onScroll={onScroll}>
            {
                notifications.length !== 0 &&
                <Table stickyHeader className={classes.tableStyle}>
                    <TableHead className={classes.bgWhite}>
                        <TableRow>
                            {
                                appConstants.notificationTableHeaders && appConstants.notificationTableHeaders.map((header, index) =>
                                    <TableCell key={`notification_${index}`} className={classes.tableHeadCell}>
                                        <TableSortLabel
                                            active={orderBy === header.key}
                                            direction={orderBy === header.key ? order : 'asc'}
                                            onClick={() => onChangeOrder(header.key)}
                                        >
                                            {header.value}
                                        </TableSortLabel>
                                    </TableCell>
                                )
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            notifications && sortTable(notifications, order, orderBy).map((notification, index) =>
                                <TableRow className={classes.tableRow} key={`data_${index}`}>
                                    <TableCell className={classes.tableCell}>
                                        {notification.type}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {notification.notification_type}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {moment(notification.created_date).format(datetimeFormat)}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {notification.notification_text}
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            }
            {
                !isPageLoading && notifications.length === 0 &&
                <Grid container justify="center" alignItems="center" direction="column" className={classes.height100p}>
                    <img className={classes.noNotificationImg} src={Nomessages} alt="No Notification yet" />
                    <Typography variant="h4" color="textSecondary" className={classes.marginTop10}>
                        No Notifications yet
                    </Typography>
                </Grid>
            }
            {isPageLoading && <Loader />}
        </Grid>
    );

};

NotificationGridView.propTypes = {
    classes: PropTypes.object,
    userAudit: PropTypes.object,
    editData: PropTypes.func,
    onScrollChange: PropTypes.func,
    isLoadingcontent: PropTypes.func,
    isPageLoading: PropTypes.bool,
    getUserBasedActivity: PropTypes.func,
    currentnotification: PropTypes.string,
    notifications: PropTypes.object
};

export default withStyles((theme) => ({
    ...NotificationStyles(theme),
    ...Styles(theme)
}), { withTheme: true })(NotificationGridView);